// extracted by mini-css-extract-plugin
export var gif = "_mf-0";